var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"index-page"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":"/static_files/icon.png","alt":"Logo"}}),_vm._v(" "),_c('nuxt-link',{attrs:{"to":"/"}},[_vm._v("\n      QR ЧЕК\n    ")]),_vm._v(" "),_c('div',{staticClass:"slogan"},[_vm._v("\n      Сканируй и зарабатывай\n    ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }